import React from 'react';
import Link from './Link';
import { assembleLinksOrderedByHighlightedLast } from '../logic/assembleLinks';
var LinkContainer = function (_a) {
    var nodes = _a.nodes, nodePositions = _a.nodePositions, highlightedNodeIds = _a.highlightedNodeIds, expandedNodeIds = _a.expandedNodeIds, hiddenLinkTypes = _a.hiddenLinkTypes;
    var links = assembleLinksOrderedByHighlightedLast(nodes, nodePositions, highlightedNodeIds, expandedNodeIds, hiddenLinkTypes);
    return (React.createElement("div", { className: 'linksContainer' },
        React.createElement("svg", null, links.map(function (link) {
            return (React.createElement(Link, { key: link.id, id: link.id, leftPosition: link.leftPosition, rightPosition: link.rightPosition, highlighted: link.highlighted, label: link.label }));
        }))));
};
export default LinkContainer;
//# sourceMappingURL=LinkContainer.js.map